
(function () {
    'use strict';

    angular.module('servicesModule')
           .controller('AddMembersController', controller);

    controller.$inject = ['$uibModalInstance', '$http', '$scope', 'existedEmployees', 'titlePage', 'roleId', 'excludedQuitDepartmentId', 'folderId', 'isHearing'];

    function controller($modalInstance, $http, $scope, existedEmployees, titlePage, roleId, excludedQuitDepartmentId, folderId, isHearing) {
        var vm = this;

        vm.translation = globalResources;

        var infiniteScrollLoadsize = (HandbookConfiguration.InfiniteScrollLoadSize == "0" || HandbookConfiguration.InfiniteScrollLoadSize == 0) ?
           0 :
           parseInt(HandbookConfiguration.InfiniteScrollLoadSize);

        

        vm.titlePage = titlePage;

        vm.search = {
            recursive: false,
            pageSize: infiniteScrollLoadsize,
            pageIndex: 0,
            firstName: '',
            lastName: '',
            roleId: null,
            excludedQuitDepartmentId: excludedQuitDepartmentId,
            folderId: folderId
        };


        vm.selectedRole = {};

        vm.getDepartment = getDepartment;
        vm.saveChanges = saveChanges;
        vm.cancel = cancel;
        vm.existedEmployees = existedEmployees;
        vm.excludedEmployees = [];

        vm.nextPage = nextPage;
        vm.searchEmployee = searchEmployee;
        vm.onSelectRow = onSelectRow;
        vm.checkAll = checkAll;
        vm.onKeyUp = onKeyUp;

        vm.isHearing = isHearing;
        vm.changeSaveSearch = changeSaveSearch;
        vm.searchPatterns = [];
        vm.searchByHearing = false;
        initialize();
        

        function initialize() {
            if (vm.isHearing) {
                getUserFilterSearches();
            }

            if (vm.existedEmployees) {
                vm.existedEmployees.forEach(function (item) {
                    vm.excludedEmployees.push(item.id);
                });
            }
            vm.total = 0;
            vm.times = 0;
            vm.currentRowIndex = 0;
            vm.selectedEmployees = [];
            vm.selectedEmployeesCount = 0;

            $http.get('/api/Users/GetSecurityGroups', {})
                .success(function (data, status, headers, config) {
                    vm.roles = data;
                })

            var promise = $http.post('/api/Users/GetEmployees',
               {
                   recursive: vm.search.recursive,
                   pageSize: vm.search.pageSize,
                   pageIndex: vm.search.pageIndex,
                   departmentId: vm.search.departmentId,
                   firstName: vm.search.firstName,
                   lastName: vm.search.lastName,
                   roleId: vm.search.roleId,
                   excludedEmployeeId: vm.excludedEmployees,
                   excludedQuitDepartmentId: vm.search.excludedQuitDepartmentId,
                   folderId: vm.search.folderId
               });

            promise.success(function (data, status, headers, config) {
                vm.employees = data;
            });
        };

        $scope.$watch('vm.employees', function (data, oldData) { // This handler for initialize data.
            var response = gridUtilities.lookupData(data, vm.rowCollection, vm.originalCollection, infiniteScrollLoadsize, vm.total, vm.currentRowIndex);
            vm.total = response.total;
            vm.currentRowIndex = response.currentIndex;
            vm.rowCollection = response.data;
        }, true);

        function nextPage(tableState) {
            vm.searchByHearing = false;
            resetselectedSearchPattern();
            if (infiniteScrollLoadsize == 0) {
                vm.rowCollection = vm.employees;
                vm.originalCollection = angular.copy(vm.rowCollection);
            } else {
                //if we reset (like after a search or an order)
                if (tableState.pagination.start === 0) {
                    if (vm.rowCollection == null || vm.rowCollection.length == 0) {
                        getAPage(true);
                        $scope.$apply();
                    }
                } else {
                    //we load more
                    getAPage(false);
                    $scope.$apply();
                }
            }
        };

        function getAPage(first) {
            vm.search.pageIndex += 1;
            vm.searchByHearing = false;
            resetselectedSearchPattern();
            vm.search.roleId = vm.selectedRole != null ? vm.selectedRole.id : null;
            var promise = $http.post('/api/Users/GetEmployees',
                {
                    recursive: vm.search.recursive,
                    pageSize: vm.search.pageSize,
                    pageIndex: vm.search.pageIndex,
                    departmentId: vm.search.departmentId,
                    firstName: vm.search.firstName,
                    lastName: vm.search.lastName,
                    roleId: vm.search.roleId,
                    excludedEmployeeId: vm.excludedEmployees,
                    folderId: vm.search.folderId
                });

            promise.success(function (data, status, headers, config) {
                if (first) {
                    vm.rowCollection = data;
                } else {
                    vm.rowCollection = vm.rowCollection.concat(data);
                }

                vm.originalCollection = angular.copy(vm.rowCollection);
            });
        }

        function searchEmployee() {
            vm.searchByHearing = false;
            resetselectedSearchPattern();
            vm.search.pageIndex = 1;
            vm.search.roleId = vm.selectedRole != null ? vm.selectedRole.id : null;
            var promise = $http.post('/api/Users/GetEmployees',
                {
                    recursive: vm.search.recursive,
                    pageSize: vm.search.pageSize,
                    pageIndex: vm.search.pageIndex,
                    departmentId: vm.search.departmentId,
                    firstName: vm.search.firstName,
                    lastName: vm.search.lastName,
                    roleId: vm.search.roleId,
                    excludedEmployeeId: vm.excludedEmployees,
                    excludedQuitDepartmentId: vm.search.excludedQuitDepartmentId,
                    folderId: vm.search.folderId
                });

            promise.success(function (data, status, headers, config) {
                vm.selectedEmployees = [];
                vm.selectedEmployeesCount = 0;

                vm.rowCollection = data;
                vm.originalCollection = angular.copy(vm.rowCollection);
            });
        };

        function onSelectRow(row) {
            if (row.selected == true) {
                vm.selectedEmployees.push(row);
                if (row != null) {
                    vm.selectedEmployeesCount += 1;
                }
            } else {
                if (row != null) {
                    if (vm.selectedEmployeesCount > 0) {
                        vm.selectedEmployeesCount -= 1;
                    }
                }

                vm.selectedEmployees.splice($.inArray(row, vm.selectedEmployees), 1);
            }
        };

        function checkAll() {
            vm.selectedEmployees = [];
            vm.selectedEmployeesCount = 0;
            if (vm.isAllSelected) {
                vm.rowCollection.forEach(function (item) {
                    item.selected = true;
                    vm.selectedEmployees.push(item);
                    vm.selectedEmployeesCount += 1;
                });
            } else {
                vm.rowCollection.forEach(function (item) {
                    item.selected = false;
                });
            }
        };

        function onKeyUp(e) {
            if (e.which == 13) {
                searchEmployee();
            }
        }
        function getDepartment(department) {
            if (department) {
                vm.search.departmentId = department.id;
            } else {
                vm.search.departmentId = null;
            }
        }

        function saveChanges() {
            if (vm.selectedEmployees && vm.selectedEmployees.length != 0) {
                $modalInstance.close(vm.selectedEmployees);
            }
        }

        function cancel() {
            $modalInstance.dismiss('cancel');
        }

        function getUserFilterSearches() {
            vm.searchPatterns = [];
            $http.get('/api/Users/GetUserSavedSearches', { params: { searchFilterType: searchFilterTypes.hearingMembers } })
                .then(function (res) {
                    if (res.data && res.data.length > 0) {
                        vm.searchPatterns = res.data;
                        vm.searchPatterns.unshift({
                            id: 0,
                            name: vm.translation.ChooseSavedHearingMembersList,
                            searchFilterType: searchFilterTypes.hearingMembers
                        });

                        vm.selectedSearchPattern = vm.searchPatterns[0];
                    }
                    vm.isHearing = (res.data && res.data.length > 0);
            });
        }

        function changeSaveSearch() {
            vm.selectedEmployees = [];
            vm.selectedEmployeesCount = 0;
            vm.search.pageIndex = 1;
            vm.searchByHearing = true;
            var selectedRequest = vm.selectedSearchPattern;
            if (!selectedRequest || !selectedRequest.searchFilters) {
                return;
            }

            var request = {
                pageIndex: 1,
                pageSize: 0,
                searchIds: selectedRequest.searchFilters,
                folderId: vm.search.folderId
            };

            $http.post('/api/users/GetEmployees', request).then(function (response) {
                if (response.data) {
                    if (!vm.excludedEmployees)
                        vm.excludedEmployees = [];
                    vm.rowCollection = response.data.filter(x => !vm.excludedEmployees.find(y => y == x.id));
                    vm.originalCollection = angular.copy(vm.rowCollection);
                }
            });
        }

        function resetselectedSearchPattern() {
            if (vm.isHearing && vm.searchPatterns.length > 0) {
                vm.selectedSearchPattern = vm.searchPatterns[0];
            }
        }
    };
})();